<template>
  <q-card class="success-dialog-container relative">
    <div class="bg-tilted"></div>
    <div class="bg-lines">
      <div class="small"></div>
      <div class="big"></div>
    </div>
    <q-card-section class="title">
      <div class="text-center">
        <slot name="dialogTitle"> Well... </slot>
      </div>
    </q-card-section>

    <q-card-section class="diamond">
      <div class="background"></div>
      <div class="outline"></div>
      <div class="status-icon absolute-center"></div>
    </q-card-section>

    <q-card-section class="subtitle">
      <slot name="subtitle">
        <span class="subtitle-bold">{{ successCount }}</span
        >/{{ machineCount }} machines were successful.
      </slot>
    </q-card-section>

    <q-card-section class="button-container text-center">
      <!--      <q-card-actions align="center" >-->
      <div>
        <q-btn
          v-close-popup
          flat
          no-caps
          class="get-csv-btn"
          @click="generateCSVReport"
        >
          <slot name="btnTitle"> Get the CSV report </slot>
        </q-btn>
      </div>
      <div>
        <q-btn
          v-close-popup
          flat
          no-caps
          class="discard-btn"
        >
          No Thanks
        </q-btn>
      </div>
      <!--      </q-card-actions>-->
    </q-card-section>
  </q-card>
</template>

<script>
export default {
  name: 'MixedDialog',
  computed: {
    successCount() {
      return this.$store.getters['main/dialogData'].successCount;
    },
    machineCount() {
      return this.$store.getters['main/dialogData'].data?.length;
    },
  },
  methods: {
    // generateCSVReport() {
    //   const headers = ['machine_name', 'status', 'action'];
    //   const data = [...this.requestData].map(req => { return { agentName: req.agentName, status: req.status, action: req.action} });
    //   this.exportCSV(headers, data, `${Date.now()}-agent-action-report`);
    // },
  },
};
</script>

<style scoped lang="scss">
.success-dialog-container {
  position: relative;
  width: 400px;
  height: 500px;
  background: white;

  .bg-tilted {
    bottom: 0;
    left: 0;
    position: absolute;
    background: $-text-text-warning;
    height: 458px;
    width: 400px;
    clip-path: polygon(0% 28%, 100% 8.4%, 100% 100%, 0% 100%);
  }

  .bg-lines {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .small,
    .big {
      position: absolute;
      width: 100%;
      height: 5px;
    }

    .small {
      top: 367px;
      background: url('@/assets/images/dialog-boxes/line-small.png') no-repeat;
      background-position-x: right;
      background-position-y: top;
    }

    .big {
      top: 378px;
      background: url('@/assets/images/dialog-boxes/line-big.png') no-repeat;
      background-position-x: right;
      background-position-y: top;
    }
  }

  .title {
    //margin-top: 32px;
    padding: 0;
    font-family: Gordita-Bold;
    font-size: 32px;
    color: black;
  }

  .diamond {
    position: absolute;
    width: 180px;
    height: 144px;
    padding: 5px;
    left: calc(50% - 90px);
    top: 111px;

    .outline {
      top: 10px;
      left: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      background: url('@/assets/images/dialog-boxes/diamond-outline.png') no-repeat;
      background-size: 100%;
    }

    .background {
      top: 0;
      left: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      background: url('@/assets/images/dialog-boxes/diamond-white-bg.png') no-repeat;
      background-size: 100%;
    }

    .status-icon {
      width: 100%;
      height: 100%;
      background: url('@/assets/images/dialog-boxes/warning.png') no-repeat;
      background-position: center;
    }
  }

  .subtitle {
    position: absolute;
    width: 290px;
    padding: 0;
    top: 298px;
    left: calc(50% - 145px);
    text-align: center;
    color: white;
    font-family: Gordita-Regular;
    font-size: 20px;
    line-height: 27px;
    .subtitle-bold {
      font-family: Gordita-Bold;
    }
  }

  .button-container {
    padding: 0;
    margin: 0;
    position: absolute;
    top: 414px;
    //bottom: 55px;
    width: 100%;
  }

  .get-csv-btn {
    min-width: 188px;
    background: white;
    border-radius: 30px;
  }

  .discard-btn {
    background: transparent;
    border-radius: 30px;
  }
}
</style>
